import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { BlueprintService } from '../../services/blueprint.service';
import { TemplateEditorService } from '../../services/template-editor.service';
import { ScrollingListService } from 'src/app/ajs-upgraded-providers';
import { PresentationsService } from 'src/app/presentations/services/presentations.service';
import { PresentationApiService } from 'src/app/api/services/presentation-api.service';
import { FolderService } from 'src/app/shared/services/folder.service';
import { FoldersApiService } from 'src/app/api/services/folders-api.service';

@Injectable({
  providedIn: 'root'
})
export class PlaylistComponentService {

  public search :any = {
    skipFirstLoad: true,
    sortBy: 'changeDate',
    reverse: true,
    folderId: ''
  };
  public templates = this.ScrollingListService(this.presentationApiService.list.bind(this.presentationApiService), this.search);
  public loading;
  public onAddHandler;
  public folderId: string | null | undefined = '';
  public folders: any[] = [];
  public loadingFolders = false;

  constructor(
    private ScrollingListService: ScrollingListService,
    private presentationApiService: PresentationApiService,
    private presentationsService: PresentationsService,
    private templateEditorFactory: TemplateEditorService,
    private blueprintFactory: BlueprintService,
    public folderService: FolderService) { }

    load() {
      this.search.query = '';
      this.search.filter = ' presentationType:"HTML Template"';
      //exclude the template that is being edited
      this.search.filter += ' AND NOT id:' + this.templateEditorFactory.presentation.id;
      this.search.folderId = this.folderId;

      this.loadingFolders = true;
      this.folderService.loadFolders('Presentation', this.search).then((folders) => {
        this.folders = folders.filter(folder => 
          this.folderService.showFolderItem(
            this.folderId || FoldersApiService.ROOT_FOLDER_ID,
            folder.parentId
          ) || (!this.folderId && this.search.query)
        );
        this.loadingFolders = false;
      }).catch(() => {
        this.loadingFolders = false;
      });

      this.templates.doSearch();
    }

    setCurrentFolder(folderId: string) {
      this.folderId = folderId || '';
      this.search.folderId = this.folderId;
      this.load(); 
    }

    get items() {
      const presentations = this.templates.items?.list?.filter(item => 
        this.folderService.showFolderItem(
          this.folderId || FoldersApiService.ROOT_FOLDER_ID,
          item.folderId
        ) || (!this.folderId && this.search.query)
      ) || [];
      
      return [...this.folders, ...presentations];
    }

    get isLoading() {
      return this.loadingFolders || this.templates.loadingItems;
    }

    loadPresentationNames(presentations) {
      var presentationIds = _.uniq(
        _.map(presentations, (item) => {
          return item.id;
        })
      );

      const lookups = [];
      const found = [];

      this.loading = true;

      for (let presentationId of presentationIds) {
        lookups.push(this.presentationsService.getPresentationCached(presentationId).then(result => {
          for (let presentation of presentations) {
            if (presentation.id === result.id) {
              if (found.indexOf(result.id) < 0) {
                found.push(result.id);
              }
              presentation.name = result.name;
              presentation.revisionStatusName = result.revisionStatusName;
              presentation.removed = false;
            }
          }
        }).catch(() => {}));
      }
      Promise.all(lookups).then(() => {
        for (let presentation of presentations) {
          if (found.indexOf(presentation.id) < 0) {
            presentation.name = 'Unknown';
            presentation.revisionStatusName = 'Presentation not found.';
            presentation.removed = true;
          }
        }
      }).finally(() => {
        this.loading = false;
      });
    }

    addTemplates () {
      var itemsToAdd = this.templates.getSelected();

      //if template supports PUD, then set it to PUD automatically
      var promises = [];
      _.forEach(itemsToAdd, (item) => {
        promises.push(this.blueprintFactory.isPlayUntilDone(item.productCode));
      });

      this.loading = true;

      Promise.all(promises)
        .then( (playUntilDoneValues) => {
          for (var i = 0; i < playUntilDoneValues.length; i++) {
            itemsToAdd[i]['play-until-done'] = playUntilDoneValues[i];
          }

          if (this.onAddHandler) {
            this.onAddHandler(itemsToAdd);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
}
